import createVueComponent from '../createVueComponent';
var BarChart = createVueComponent('BarChartIcon', [['line', {
  x1: '12',
  y1: '20',
  x2: '12',
  y2: '10',
  key: '1wi7jb'
}], ['line', {
  x1: '18',
  y1: '20',
  x2: '18',
  y2: '4',
  key: '1mwru6'
}], ['line', {
  x1: '6',
  y1: '20',
  x2: '6',
  y2: '16',
  key: 'zj13da'
}]]);
export default BarChart;